import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'SpaceAnalyticsPage.Section.ChatbotSection.Title',
    defaultMessage: 'Chatbot Overview'
  },

  titleSubText: {
    id: 'SpaceAnalyticsPage.Section.ChatbotSection.TitleSubText',
    defaultMessage:
      'Includes members who have sent a message to the chatbot, messages sent, and number of chat sessions'
  },

  uniqueMembers: {
    id: 'SpaceAnalyticsPage.Section.ChatbotSection.UniqueMembers',
    defaultMessage: 'UNIQUE MEMBERS'
  },

  totalMessages: {
    id: 'SpaceAnalyticsPage.Section.ChatbotSection.TotalMessages',
    defaultMessage: 'TOTAL MESSAGES'
  },

  sessions: {
    id: 'SpaceAnalyticsPage.Section.ChatbotSection.Sessions',
    defaultMessage: 'SESSIONS'
  }
})
